import { useEffect, useRef, useState } from 'react';
import i18n from '../../assets/i18n/config';
// import chevronUp from '../../../public/icons/chevron_up_alt_blue.svg';
// import chevronDown from '../../../public/icons/chevron_down_alt_blue.svg';

export const ChangeLanguage = () => {
    const selectorRef = useRef<HTMLSelectElement>(null);
    const [openSelector, setOpenSelector] = useState<boolean>(false)
    const changeLanguage = (event: React.ChangeEvent<HTMLSelectElement>) => {
        i18n.changeLanguage(event.target.value);
    };

    useEffect(() => {
        const lang = i18n.language.split('-')[0];
        (selectorRef.current as HTMLSelectElement).value = lang

        if(lang === 'es') {
            i18n.changeLanguage('es');
        } else if(lang === 'en') {
            i18n.changeLanguage('en');
        } else {
            i18n.changeLanguage('en');
        }
    },[]);
    return (
        <div className='select-lang__container' onClick={() => setOpenSelector(!openSelector)}>
            <i className="fas fa-earth-americas" />
            <select
                ref={selectorRef}
                data-testid="select-language"
                onBlur={() => setOpenSelector(false)}
                defaultValue={i18n.language}
                className="select-lang"
                // style={{backgroundImage: openSelector ? `url('${chevronUp}')` : `url('${chevronDown}')`}}
                onChange={changeLanguage}
            >
                <option value="en">
                    En
                </option>
                <option value="es">
                    Es
                </option>
            </select>
        </div>
    );
};
